import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
  [ModulesConfigMap[ModulesMap.DONE_WORKS_ALL_FIELD_WORKS].GET_DONE_WORKS_ALL_FIELD_WORKS]:{
    url:'/company/:companyId/done_works/all_field_works/'
  }
}